import { render, staticRenderFns } from "./HeatMapCoords.vue?vue&type=template&id=1c989d0c&scoped=true"
import script from "./HeatMapCoords.vue?vue&type=script&lang=js"
export * from "./HeatMapCoords.vue?vue&type=script&lang=js"
import style0 from "./HeatMapCoords.vue?vue&type=style&index=0&id=1c989d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c989d0c",
  null
  
)

export default component.exports